import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=3dc7f434"
import script from "./BankAccountForm.vue?vue&type=script&lang=js"
export * from "./BankAccountForm.vue?vue&type=script&lang=js"
import style0 from "./BankAccountForm.vue?vue&type=style&index=0&id=3dc7f434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports